import React, { useMemo } from 'react';
import clsx from 'clsx';

import CommonDropdown from './CommonDropdown';
import Icon from '../../icons/Icon';
import Emoji from '../emoji/Emoji';

const DropdownWithIcons = ({
  options = [],
  onSelect,
  disabled,
  value = '',
  placeholder,
  maxWidth,
  isEmojiIcons,
  stressedIcons,
  preserveIconColors = false,
  ...rest
}) => {
  const selectedOption = useMemo(() => options.find((op) => op.value === value), [value, options]);

  const IconComponent = useMemo(() => {
    if (!selectedOption?.icon) {
      return null;
    }

    if (isEmojiIcons) {
      return <Emoji symbol={selectedOption.icon} label={selectedOption.value} />;
    }

    return (
      <Icon
        icon={selectedOption.icon}
        disableCommonColors
        className={clsx(
          selectedOption.iconClassName,
          selectedOption.isStrokeIcon ? 'common-dropdown_item_icon--stroke' : 'common-dropdown_item_icon--fill',
        )}
      />
    );
  }, [selectedOption, isEmojiIcons, stressedIcons, preserveIconColors]);

  return (
    <CommonDropdown
      value={value}
      options={options}
      onSelect={onSelect}
      disabled={disabled}
      placeholder={placeholder}
      maxWidth={maxWidth}
      withIcons
      isEmojiIcons={isEmojiIcons}
      {...rest}
      LeftIcon={IconComponent}
    />
  );
};

export default DropdownWithIcons;
